export enum STOP_TYPE {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

export enum STOP_TYPE_ABB {
  DS = 'DS',
  PS = 'PS',
}

export enum DENSITY_ABB {
  R = 'R',
  C = 'C',
  U = 'U',
}

export enum DENSITY {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
  UNKNOWN = 'UNKNOWN',
}

export enum DENSITY_WITH_ABB {
  RESIDENTIAL = 'R-RESIDENTIAL',
  COMMERCIAL = 'C-COMMERCIAL',
  UNKNOWN = 'U-UNKNOWN',
}

export enum DAYS_ASSIGNED {
  SU = 'Su',
  MO = 'Mo',
  TU = 'Tu',
  WE = 'We',
  TH = 'Th',
  FR = 'Fr',
  SA = 'Sa',
}
